import { ContactControlButtonProps } from './contact-control-button-props';

export interface CallControlButton {
  hold: ContactControlButtonProps;
  mute: ContactControlButtonProps;
  end: ContactControlButtonProps;
  mask: ContactControlButtonProps;
  record: ContactControlButtonProps;
  transfer: ContactControlButtonProps;
}
